import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import { Field, FormikProvider, useFormik } from 'formik'
import CustomInput from '../../../components/common/CustomInput'
import * as Yup from 'yup'
import CustomSelect from '../../../components/common/CustomSelect'
import CustomFile from '../../../components/common/CustomFile'

const validationSchema = Yup.object({
  company: Yup.string().required('Company is required'),
  name: Yup.string().trim().required('Series Name is required'),
  logo: Yup.mixed().required('Series Logo is required'),
})

const Add = () => {
  const navigate = useNavigate()
  const [companyOptions, setCompanyOptions] = useState([])

  const fetchCompanyData = async () => {
    try {
      const response = await axiosAuthInstance.get('company/dropdown')
      if (response && response.status === 200) {
        const transformedData = response?.data?.result?.map((item) => ({
          value: item._id,
          label: item.name,
        }))
        setCompanyOptions(transformedData)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();
      formData.append('company', values.company);
      formData.append('name', values.name);
      formData.append('logo', values.logo);

      const response = axiosAuthInstance.post('series/add', formData)
      if (response) {
        navigate('/series')
      }
    } catch (error) {
      console.log(error)
    }
  }
  const formik = useFormik({
    onSubmit: (values, formikHelpers) => handleSubmit(values, formikHelpers),
    validationSchema,
    initialValues: {
      company: '',
      name: '',
      logo: null,
    },
  })

  useEffect(() => {
    fetchCompanyData()
  }, [])

  return (
    <FormikProvider value={formik}>
      <form
        className='flex flex-col p-4 gap-4'
        onSubmit={(e) => {
          e.preventDefault()
          formik.handleSubmit()
        }}
      >
        <Field
          name="company"
          label="Company"
          placeholder="Company"
          required
          component={CustomSelect}
          options={companyOptions}
        />

        <Field
          name='name'
          label='Series Name'
          placeholder='Series Name'
          required
          component={CustomInput}
        />

        <Field
          name='logo'
          label='Series Logo'
          placeholder='Upload Series Logo'
          required
          accept="image/*"
          component={CustomFile}
        />

        <button
          type='submit'
          disabled={formik.isSubmitting}
          className='bg-primary text-xl font-medium text-white rounded-lg px-6 py-2'
        >
          Add
        </button>
      </form>
    </FormikProvider>
  )
}

export default Add
